export class MergeLines {
    constructor(
      public servingLineTrackingId: String | undefined,
      public mergedIntoLineTrackingId: String | undefined,
      public discarded: Boolean = false,
      public mergedDateTimeUtc: string = ''
    ) {
    }
}